import styled from 'styled-components';

const ExpandedItemsWrapper = styled.div`
  display: flex;
  gap: 16px;
`;

export default ExpandedItemsWrapper;
